import { guideList } from "../../utils/policyUtils";
import React from "react";
import { useMembership } from "../../hooks/MembershipProvider/MembershipProvider";
import useAndroidBridge from "../../hooks/useAndroidBridge";
import { useLocation, useNavigate } from "react-router-dom";

const Guide = () => {
  const { isEmbed } = useMembership();
  const { sendToAndroid } = useAndroidBridge();
  const navigate = useNavigate();
  const loaction = useLocation();

  const goBack = () => {
    let { search } = loaction;
    if (search) {
      sendToAndroid("go-to-page", "mystate");
    } else {
      navigate(-1);
    }
  };
  
  return (
    <>
      {isEmbed() && (
        <div className={`mobile_app_header !bg-[#F0EEEA] !justify-end`}>
          <button onClick={goBack} className={`btn btn_close`}></button>
          {/*<p className={`mobile_app_header_text`}>내 정보</p>*/}
        </div>
      )}
      <div className={`content_wrap guide`}>
        <div className={`section_wrap sec_wrap_1`}>
          <div className={`sec sec_1`}>
            <h3 className={`text-center h3`}>책이 만들어지는 순서</h3>
            <section className="guide_timeline">
              <div className="step">
                <div className="step-header">
                  <span className="step-number">1</span>
                  <h2>인터뷰 진행</h2>
                  <span className="duration-badge">20일~30일</span>
                </div>
                <div className="step-content">
                  <p>인터뷰를 천천히 완료해 주세요. 모두 끝나면 다음 단계로 넘어갈 수 있어요.</p>
                </div>
              </div>
              
              <div className="step">
                <div className="step-header">
                  <span className="step-number">2</span>
                  <h2>전자책 신청</h2>
                  <span className="duration-badge">1분</span>
                </div>
                <div className="step-content">
                  <p>인터뷰가 끝나면 에서 전자책 신청 버튼을 눌러 주세요. (홈 화면 우측 상단)</p>
                  <div className="warning-box">
                    전자책 신청 후에는 인터뷰 추가/삭제/수정 이 불가능해요.
                  </div>
                </div>
              </div>
              
              <div className="step">
                <div className="step-header">
                  <span className="step-number">3</span>
                  <h2>전자책 편집</h2>
                  <span className="duration-badge">1~3시간</span>
                </div>
                <div className="step-content">
                  <p>책에 들어갈 사진을 추가하고, 필요 시 글 내용을 직접 수정해 주세요.</p>
                </div>
              </div>
              
              <div className="step">
                <div className="step-header">
                  <span className="step-number">4</span>
                  <h2>실물책 신청</h2>
                  <span className="premium-badge rounded-full">프리미엄 전용</span>
                  <span className="duration-badge">2분</span>
                </div>
                <div className="step-content">
                  <p>전자책 편집 완료 후, 실물책 신청 버튼을 눌러주세요. (전자책 보기 화면 우측 하단)</p>
                  <div className="warning-box">
                    실물책 신청 후에는 내용 수정/ 사진 추가/ 신청 정보 수정이 불가능해요.
                  </div>
                </div>
              </div>
              
              <div className="step last-step">
                <div className="step-header">
                  <span className="step-number">5</span>
                  <h2>편집·인쇄·배송</h2>
                  <span className="premium-badge rounded-full">프리미엄 전용</span>
                  <span className="duration-badge">2분</span>
                </div>
                <div className="step-content">
                  <p>기억의 서랍에서 고객님의 자서전 책을 인쇄하고, 배송합니다.</p>
                </div>
              </div>
            </section>
            {/*<div className={`table_box`}>*/}
            {/*  <table className={`table rounded-xl overflow-hidden`}>*/}
            {/*    <thead className={``}>*/}
            {/*      <tr className={`text-center`}>*/}
            {/*        <th>*/}
            {/*          <p className={`md:hidden`}>순서</p>*/}
            {/*          <p className={`max-md:hidden`}>진행 순서</p>*/}
            {/*        </th>*/}
            {/*        <th>진행 상태</th>*/}
            {/*        <th>소요 기간</th>*/}
            {/*        <th className={`max-md:hidden`}>설명</th>*/}
            {/*      </tr>*/}
            {/*    </thead>*/}
            {/*    <tbody>*/}
            {/*      {guideList?.map((obj: any, idx: any) => {*/}
            {/*        return (*/}
            {/*          <tr key={idx}>*/}
            {/*            <td className={`text-center`}>{obj?.step}</td>*/}
            {/*            /!* orangeYn이 true인 경우 오렌지색으로 표시 *!/*/}
            {/*            <td*/}
            {/*              className={`${*/}
            {/*                obj?.orangeYn === "true" && "orange"*/}
            {/*              } text-center`}*/}
            {/*            >*/}
            {/*              {obj?.state()}*/}
            {/*            </td>*/}
            {/*            <td className={`text-center`}>{obj?.date}</td>*/}
            {/*            <td className={`max-md:hidden`}>{obj?.desc()}</td>*/}
            {/*          </tr>*/}
            {/*        );*/}
            {/*      })}*/}
            {/*    </tbody>*/}
            {/*  </table>*/}
            {/*</div>*/}
            {/*<div className={`mt-5`}>*/}
            {/*  <p className={`caption mb-2`}>*/}
            {/*    *상품별로 정해진 이용 기간 내에 전자책 신청, 실물책 신청을*/}
            {/*    완료해 주세요.*/}
            {/*  </p>*/}
            {/*  <p className={`caption mb-2`}>*/}
            {/*    *소요 기간은 상황에 따라 달라질 수 있습니다.*/}
            {/*  </p>*/}
            {/*  <p className={`caption`}>*/}
            {/*    *나의 현재 진행 상황은 [웹-마이페이지], [앱-메뉴-스토리북*/}
            {/*    현황]에서 확인할 수 있습니다.*/}
            {/*  </p>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default Guide;
